import React from 'react';
import SkeletonCard from './SkeletonCard';
import SkeletonTable from './SkeletonTable';
import SkeletonChart from './SkeletonChart';
interface PageSkeletonProps {
  type?: 'dashboard' | 'connections' | 'collaborations';
}
const PageSkeleton: React.FC<PageSkeletonProps> = ({
  type = 'dashboard'
}) => {
  return <div className="p-6 animate-pulse" data-id="element-655">
      {/* Page Header */}
      <div className="mb-6" data-id="element-656">
        <div className="h-8 bg-gray-200 rounded w-1/4 mb-2" data-id="element-657"></div>
        <div className="h-4 bg-gray-200 rounded w-1/2" data-id="element-658"></div>
      </div>
      {/* Metrics Cards */}
      <div className="mb-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-659">
        {Array(4).fill(0).map((_, i) => <SkeletonCard key={`metric-${i}`} height="h-28" data-id="element-660" />)}
      </div>
      {type === 'dashboard' && <>
          {/* Impact Widget */}
          <div className="mb-8" data-id="element-661">
            <SkeletonCard height="h-96" data-id="element-662" />
          </div>
          {/* Charts */}
          <div className="mb-8 grid grid-cols-1 gap-8 lg:grid-cols-2" data-id="element-663">
            <SkeletonChart data-id="element-664" />
            <SkeletonChart data-id="element-665" />
          </div>
          <div className="mb-8" data-id="element-666">
            <SkeletonChart data-id="element-667" />
          </div>
        </>}
      {/* Table */}
      <SkeletonTable rows={type === 'dashboard' ? 5 : 10} columns={type === 'collaborations' ? 6 : type === 'connections' ? 7 : 5} data-id="element-668" />
      {type !== 'dashboard' && <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-669">
          <SkeletonCard height="h-64" data-id="element-670" />
          <SkeletonCard height="h-64" data-id="element-671" />
        </div>}
    </div>;
};
export default PageSkeleton;